<template>
	<div class="certificate-list">
		<b-row class="mb-3">

			<b-col cols="3" v-if="companyType !== 'SHOP' ">
				<b-form-select
					v-model="filter.category"
					:options="allCategory"
					value-field="id"
					text-field="name"
				>
					<template slot="first">
						<option value="all">-- Все Категории --</option>
					</template>
				</b-form-select>
			</b-col>
			<b-col cols="3">
				<b-form-select
					v-model="subcategory.value"
					:disabled="subcategory.isDisabled"

				>
					<option v-for="(selectOption, indexOpt) in subcategory.items"
							:key="indexOpt"
							:value="selectOption.id"
					>
						{{ selectOption.name }}
					</option>
					<template slot="first">
						<option :value="null">--
							{{ companyType === 'SHOP' ? $t('incomes.block-counteragent.group') : 'Все Под категории' }}
							--
						</option>
					</template>
				</b-form-select>

			</b-col>
			<b-col cols="3">
				<b-form-select
					v-model="subsubcategory.value"
					:disabled="subsubcategory.isDisabled"

				>
					<option v-for="(selectOption, indexOpt) in subsubcategory.items"
							:key="indexOpt"
							:value="selectOption.id"
					>
						{{ selectOption.name }}
					</option>
					<template slot="first">
						<option :value="null">--
							{{
								companyType === 'SHOP' ? $t('incomes.block-counteragent.category') : 'Все Под категории'
							}}
							--
						</option>
					</template>
				</b-form-select>

			</b-col>
			<b-col cols="3">
				<b-form-select
					v-model="sub3category.value"
					:disabled="sub3category.isDisabled"

				>
					<option v-for="(selectOption, indexOpt) in sub3category.items"
							:key="indexOpt"
							:value="selectOption.id"
					>
						{{ selectOption.name }}
					</option>
					<template slot="first">
						<option :value="null">--
							{{ companyType === 'SHOP' ? $t('goods.subcategory') : 'Все Под категории' }}
							--
						</option>
					</template>
				</b-form-select>
			</b-col>
			<b-col cols="3">
				<multiselect
					v-model="colors.value"
					:options="colors.items"
					track-by="id"
					:show-labels="false"
					:allow-empty="true"
					label="name"
					:placeholder="$t('goods.create.color')"
					class="multiselect-pricing"
				>
				</multiselect>
			</b-col>

		</b-row>
		<b-row class="mb-3">
			<b-col cols="3">
				<b-form-input id="name"
							  v-model="filter.name"
							  name="name"
							  :placeholder="$t('goods.create.name')+'/'+$t('goods.artikul')"
							  v-on:keyup.enter="accept"

				>
				</b-form-input>
			</b-col>

			<b-col cols="3">
				<b-form-input id="barcode"
							  v-model="filter.barCode"
							  name="barcode"
							  :placeholder="$t('goods.special-barcode')"
							  v-on:keyup.enter="accept"
				>
				</b-form-input>
			</b-col>
<!--			<b-col cols="3" v-if="companyType === 'SHOP' || categoryCode === 'MAGAZIN'">-->
<!--				<b-form-select-->
<!--					v-model="filter.genderId"-->
<!--				>-->
<!--					<option v-for="(selectOption, indexOpt) in genders"-->
<!--							:key="indexOpt"-->
<!--							:value="selectOption.id"-->
<!--					>-->
<!--						{{ selectOption.name }}-->
<!--					</option>-->
<!--					<template slot="first">-->
<!--						<option :value="null">&#45;&#45; {{ $t('goods.gender') }} &#45;&#45;</option>-->
<!--					</template>-->
<!--				</b-form-select>-->

<!--			</b-col>-->
<!--			<b-col cols="3">-->
<!--				<b-form-select-->
<!--					v-model="filter.brandId"-->
<!--				>-->
<!--					<option v-for="(selectOption, indexOpt) in brands"-->
<!--							:key="indexOpt"-->
<!--							:value="selectOption.id"-->
<!--					>-->
<!--						{{ selectOption.name }}-->
<!--					</option>-->
<!--					<template slot="first">-->
<!--						<option :value="null">&#45;&#45; {{ $t('goods.brand') }} &#45;&#45;</option>-->
<!--					</template>-->
<!--				</b-form-select>-->
<!--			</b-col>-->
			<b-col cols="3">
				<b-form-input
					id="multiBarcode"
					v-model="filter.multiBarcode"
					name="multiBarcode"
					:placeholder="$t('goods.barcode')"
					v-on:keyup.enter="accept"
				/>
			</b-col>
			<b-col cols="3">
				<multiselect
					v-model="contragentIds"
					:options="contragents"
					:multiple="true"
					track-by="id"
					:show-labels="false"
					:allow-empty="true"
					label="fullName"
					:placeholder="$t('incomeFilter.contragent')"
					class="multiselect-pricing"
					@search-change="contragent"
				/>
			</b-col>
		</b-row>
		<b-row>
			<b-col cols="3">
				<b-form-input
					id="mxikCode"
					v-model="filter.mxikCode"
					name="mxikCode"
					placeholder="MXIK"
					:disabled="filter.isNullMxik"
					v-on:keyup.enter="accept"
				/>
				<b-checkbox v-model="filter.isNullMxik" switch/>
			</b-col>
			<b-col>
				<b-button @click="accept" class="pull-right ml-3" variant="primary">{{ $t('apply') }}</b-button>
				<b-button @click="downloadExcel" class="pull-right" variant="success"><i class="fa fa-download mr-1"/> Excel</b-button>
			</b-col>
		</b-row>
		<hr>
	</div>
</template>

<script>
import Multiselect from 'vue-multiselect'
import MaskedInput from 'vue-masked-input'
import {mapActions, mapGetters} from 'vuex'
import ReferencesService from "../../../../services/references.sevice";
import {TokenService} from "../../../../services/storage.service"
import ContrAgentService from '../../../../services/contragent.service'
import GoodsService from '../../../../services/goods.service'

export default {
	name: 'Filter-Warehouse',
	components: {MaskedInput, Multiselect},
	data() {
		return {
			page: 1,
			limit: 20,
			filter: {
				departmentId: null,
				start: '',
				end: '',
				depsId: [],
				barCode: null,
				name: null,
				category: 'all',
				genderId: null,
				brandId: null,
				multiBarcode: null,
				mxikCode: null,
				isNullMxik: false,
			},
			subcategory: {
				items: [],
				value: null,
				isDisabled: true,
			},
			subsubcategory: {
				items: [],
				value: null,
				isDisabled: true,

			},
			sub3category: {
				items: [],
				value: null,
				isDisabled: true,
			},
			colors: {
				items: [],
				value: null
			},
			companyType: '',
			categoryCode: null,
			allCategory: [],
			genders: [],
			brands: [],
			disabled: true,
			search: {},
			contragents: [],
			contragentIds: null,
			countragentName:'',
		}
	},
	watch: {
		'filter.isNullMxik': {
			handler(m) {
				if (m) {
					this.filter.mxikCode = ''
					this.checkAlreadyInSearch('isNullMxik', m)
				} else {
					this.removeSubCategoryId('isNullMxik')
				}
			}
		},
		'filter.category': {
			handler(newValue) {
				if (newValue === 'all') {
					this.subcategory.value = null;
					this.subcategory.isDisabled = true;
					this.subsubcategory.value = null;
					this.removeSubCategoryId('categoryId')
				} else {
					this.checkAlreadyInSearch('categoryId', newValue)
					this.subcategory.value = null
					this.subcategory.isDisabled = false
					this.subsubcategory.isDisabled = true
					this.subsubcategory.value = null
					this.sub3category.value = null
					this.sub3category.isDisabled = true
					this.loadSubCategory(newValue)
				}

				this.removeSubCategoryId('sub')
				this.removeSubCategoryId('sub2')
				this.removeSubCategoryId('sub3')

				this.setCategoryCode(newValue);
			}
		},
		'subcategory.value': {
			handler(newValue) {
				if (newValue === null) {
					this.subsubcategory.value = null
					this.subsubcategory.isDisabled = true
					this.removeSubCategoryId('sub')
				} else {
					this.checkAlreadyInSearch('sub', newValue)
					this.subsubcategory.isDisabled = false
					this.loadSubSubCategory(newValue)
				}
				this.sub3category.value = null
				this.sub3category.isDisabled = true
				this.removeSubCategoryId('sub2')
				this.removeSubCategoryId('sub3')

			}
		},
		'subsubcategory.value': {
			handler(newValue) {
				if (newValue === null) {
					this.sub3category.value = null
					this.sub3category.isDisabled = true
					this.removeSubCategoryId('sub2')
				} else {
					this.checkAlreadyInSearch('sub2', newValue)
					this.sub3category.isDisabled = false
					this.loadSub3Category(newValue)
				}
				this.removeSubCategoryId('sub3')

			}
		},
		'sub3category.value': {
			handler(newValue) {
				if (newValue === null) {
					this.removeSubCategoryId('sub3')
				} else {
					this.checkAlreadyInSearch('sub3', newValue)
				}

			}
		},
		'colors.value': {
			handler(newValue) {
				if (this.colors.value) {
					this.checkAlreadyInSearch('colorId', newValue.id)

				} else {
					this.checkAlreadyInSearch('colorId', null)
				}

			}
		},
		'filter.name': {
			handler(newValue) {
				if (this.filter.name !== '') {
					this.checkAlreadyInSearch('name', newValue)
				} else {
					this.removeSubCategoryId('name')
				}
			}
		},
		'filter.mxikCode': {
			handler(newValue) {
				if (this.filter.mxikCode !== '') {
					this.checkAlreadyInSearch('mxikCode', newValue)
				} else {
					this.removeSubCategoryId('mxikCode')
				}
			}
		},
		'filter.genderId': {
			handler(newValue) {
				if (this.filter.genderId !== null) {
					this.checkAlreadyInSearch('genderId', newValue)
				} else {
					this.removeSubCategoryId('genderId')
				}
			}
		},
		'filter.brandId': {
			handler(newValue) {
				if (this.filter.brandId !== null) {
					this.checkAlreadyInSearch('brandId', newValue)
				} else {
					this.removeSubCategoryId('brandId')
				}
			}
		},
		'filter.barCode': {
			handler(newValue) {

				if (this.filter.barcode !== '') {
					this.checkAlreadyInSearch('barcode', newValue)
				} else {
					this.removeSubCategoryId('barcode')
				}
			}
		},
		'contragentIds': {
			handler(newValue) {
				if (this.contragentIds !== '') {
					this.checkAlreadyInSearch('contragentIds', newValue.map(t=>t.id))
				} else {
					this.removeSubCategoryId('contragentIds')
				}
			}
		},
		'filter.multiBarcode': {
			handler(newValue) {
				if (this.filter.multiBarcode !== '') {
					this.checkAlreadyInSearch('multiBarcode', newValue)
				} else {
					this.removeSubCategoryId('multiBarcode')
				}
			}
		}
	},
	computed: {
		...mapGetters('departments', [
			'myDepartments'
		]),
		listWarehouse() {
			return this.myDepartments.filter(item => {
				return item.typeName === 'COMPANY' || item.typeName === 'SHOP';
			})
		}
	},
	methods: {
		async loadColors() {
			let response = await ReferencesService.getReferenceChildren(`color`);
			this.colors.items = response.data;
		},
		...mapActions('departments', ['fetchMyDepartments']),
		checkAlreadyInSearch(field, newValue) {
			delete this.search[field]
			this.search[field] = newValue
		},
		loadBrands() {
			ReferencesService.getReferenceChildren(`item_brand`).then(response => {
				this.brands = response.data;
			})
		},
		setCategoryCode(value) {
			if (value !== 'all') {
				this.allCategory.filter(el => {
					if (el.id === value) {
						this.categoryCode = el.code
					}
				})
			} else {
				this.categoryCode = null
			}

		},
		removeSubCategoryId(field) {
			delete this.search[field]
		},
		async loadCategory() {
			await ReferencesService.getReferenceChildren(`WAREHOUSE_CATEGORY`).then(response => {
				this.allCategory = response.data;
			})
		},
		async contragent(v) {
			let payload = {
				page: this.page,
				limit: this.limit,
				contragentIds: v
			}
			await ContrAgentService.searchContragent(payload).then(res => {
				this.contragents = res.data.items;
			})
		},

		loadSubCategory(id) {
			ReferencesService.getSubReferenceChildren(id).then(response => {
				this.subcategory.items = response.data;
			})
		},
		loadSubSubCategory(id) {
			ReferencesService.getSubReferenceChildren(id).then(response => {
				this.subsubcategory.items = response.data;
			})
		},
		loadSub3Category(id) {
			ReferencesService.getSubReferenceChildren(id).then(response => {
				this.sub3category.items = response.data;
			})
		},
		/**+
		 * Load genders
		 */
		loadGenders() {
			ReferencesService.getReferenceChildren('GENDER').then(response => {
				this.genders = response.data;
			})
		},

		setCompanyType() {
			this.companyType = TokenService.getDepartmentType()
			if (this.companyType === 'SHOP') {

				this.allCategory.filter(el => {
					if (el.code === 'MAGAZIN') {
						this.category = el.id
						this.categoryCode = el.code
					}
				})

				this.loadSubCategory(this.category)
				this.subcategory.isDisabled = false;
			}

		},
		accept() {
			if (Object.keys(this.search).length !== 0) {
				this.$emit('search', this.search);
			} else
				this.$emit('search', {});
		},
		downloadExcel() {
			if (Object.keys(this.search).length !== 0) {
				this.$emit('download', this.search);
			} else
				this.$emit('download', {});
		}
	},
	async created() {
		this.fetchMyDepartments();
		await this.loadCategory();
		this.setCompanyType();
		this.loadGenders();
		this.loadBrands();
		await this.loadColors();
		await this.contragent();
	},

}
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped>
.editBtn {
	font-size: 14px;
	cursor: pointer;
}

.filter-frame {
	padding-bottom: 15px;
}

.slide-enter, .slide-leave-to {
	transform: scaleY(0);
}

.certificateGenerate {
	background: transparent !important;
	border: none;
	padding: 7px;
	font-size: 16px;
}

.certificateGenerate span {
	margin-left: 5px;
}

.top-card {
	display: flex;
	justify-content: space-between;
	align-items: center;
}

.search_btn {
	width: 100%;
	display: flex;
	justify-content: flex-end;
	padding-right: 25px
}

input[type=number]::-webkit-inner-spin-button,
input[type=number]::-webkit-outer-spin-button {
	-webkit-appearance: none;
	margin: 0;
}
</style>

